var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Polaris-SettingAction"
  }, [_c('div', {
    staticClass: "Polaris-SettingAction__Setting"
  }, [_vm._t("children")], 2), _vm._v(" "), (_vm.$slots.action || _vm.action) ? _c('div', {
    staticClass: "Polaris-SettingAction__Action"
  }, [_vm._t("action", [(_vm.action) ? _c('polaris-button', {
    attrs: {
      "primary": "",
      "url": _vm.action.url,
      "destructive": _vm.action.destructive,
      "disabled": _vm.action.disabled,
      "icon": _vm.action.icon,
      "accessibility-label": _vm.action.accessibilityLabel
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.action)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.action.content) + "\n            ")]) : _vm._e()])], 2) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-03817952", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03817952","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisSettingAction.vue
// module id = 132
// module chunks = 0